import { useContext } from 'react';
import { MultiChainStatesContext } from '../providers';
import { useChainId } from './useChainId';
/**
 * @public
 */
export function useChainState() {
  var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var multiChainState = useContext(MultiChainStatesContext);
  var chainId = useChainId({
    queryParams: queryParams
  });
  if (chainId === undefined) {
    return undefined;
  }
  return Object.assign(Object.assign({}, multiChainState.chains[chainId]), {
    dispatchCalls: multiChainState.dispatchCalls
  });
}